import { Page } from '../../types'

const criminalProsecutionsFraud: Page[] = [
    {
        pageType: 'question',
        title: 'Criminal prosecutions for fraud',
        name: 'criminal-prosecutions-fraud',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'How many prosecutions were referred?',
                name: 'criminal-prosecutions-fraud-referred',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'instanceInput',
                title: 'How many prosecutions proceeded to charge?',
                name: 'criminal-prosecutions-fraud-proceeded',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'instanceInput',
                title: 'How many prosecutions were successful?',
                name: 'criminal-prosecutions-fraud-successful',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default criminalProsecutionsFraud
